import React from 'react';
import Feature from '../../components/feature/Feature';
import './features.css';

const featuresData = [
  {
    title: 'Free Demo Classes',
    text: 'We offer free demo classes to new students so parents can evaluate quality before committing.',
  },
  {
    title: 'One-to-One Interaction',
    text: 'Dedicated one-on-one sessions mean students get personal attention and can clear doubts instantly.',
  },
  {
    title: 'Monthly Assessments',
    text: 'We conduct monthly assessments to track each student\'s learning growth and adjust accordingly.',
  },
  {
    title: 'Cost Effective',
    text: 'Premium-quality teachers at the most competitive prices — quality education shouldn\'t be expensive.',
  },
];

const Features = () => (
  <div className="gpt3__features" id="features">
    <div className="gpt3__features-heading">
      <h1 className="gradient__text">The Future is Now — Step In Today & Make It Happen.</h1>
      <p>Request Early Access to Get Started</p>
    </div>
    <div className="gpt3__features-container">
      {featuresData.map((item, index) => (
        <Feature title={item.title} text={item.text} key={item.title + index} />
      ))}
    </div>
  </div>
);

export default Features;